var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.roles),function(role){return _c('div',{key:role},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(role === 'NOOS_ADMIN')?_c('v-icon',_vm._g(_vm._b({attrs:{"color":"#B83835"}},'v-icon',attrs,false),on),[_vm._v("\n          person\n        ")]):_vm._e()]}}],null,true)},[_c('span',[_vm._v("Administrateur")])])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }